const SWITCH_THEME = "SWITCH_THEME";
const THEME_TYPES = {
    SWITCH_THEME
};

const CHANGE_FONTSIZE = "CHANGE_FONTSIZE";
const FONTSIZE_TYPES = {
    CHANGE_FONTSIZE,
};

const LOG_IN = "LOG_IN";
const LOG_OUT = "LOG_OUT";
const GENERATE_TOKEN = "GENERATE_TOKEN";
const AUTH_TYPES = {
    LOG_IN,
    LOG_OUT,
    GENERATE_TOKEN
};

const ERROR = "ERROR";
const ERROR_TYPES = {
    ERROR
};

export {
    THEME_TYPES,
    FONTSIZE_TYPES,
    AUTH_TYPES,
    ERROR_TYPES
}